// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { FaUser, FaLock, FaEye, FaEyeSlash, FaKey } from 'react-icons/fa'; // Added FaKey
// import './Login.css';

// import topLogo from './logo-placeholder.png'; 
// import bottomTorch from './torch-placeholder.png'; 

// const Login = () => {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [loaded, setLoaded] = useState(false);
  
//   // State to toggle between Login and Forgot Password view
//   const [isResetMode, setIsResetMode] = useState(false); 

//   const [contact, setContact] = useState('');
//   const [password, setPassword] = useState('');

//   useEffect(() => {
//     setLoaded(true);
//   }, []);

//   const handleContactChange = (e) => {
//     const value = e.target.value;
//     if (/^\d*$/.test(value) && value.length <= 10) {
//       setContact(value);
//     }
//   };

//   // --- FUNCTION 1: LOGIN ---
//   const handleLogin = async () => {
//     if (contact.length < 10 || !password) {
//       alert("Please fill all fields.");
//       return;
//     }
//     try {
//       const response = await fetch('http://localhost:5000/login', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ contact, password }),
//       });
//       const data = await response.json();
//       if (data.success) {
//         navigate('/home', { state: { user: data.user } });
//       } else {
//         alert("Login Failed: " + data.message);
//       }
//     } catch (error) {
//       console.error(error);
//       alert("Server Error");
//     }
//   };

//   // --- FUNCTION 2: RESET PASSWORD ---
//   const handleResetPassword = async () => {
//     if (contact.length < 10 || !password) {
//       alert("Please enter Mobile Number and New Password.");
//       return;
//     }
//     try {
//       const response = await fetch('http://localhost:5000/forgot-password', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ 
//             contact: contact, 
//             newPassword: password // We reuse the password field for the new password
//         }),
//       });
//       const data = await response.json();
//       if (data.success) {
//         alert("Success! Password changed. Please Login now.");
//         setIsResetMode(false); // Switch back to Login mode
//         setPassword(''); // Clear field
//       } else {
//         alert("Error: " + data.message);
//       }
//     } catch (error) {
//       console.error(error);
//       alert("Server Error");
//     }
//   };

//   return (
//     <div className="main-wrapper">
//       <div className="shape shape-1"></div>
//       <div className="shape shape-2"></div>

//       <div className={`login-content ${loaded ? 'fade-in' : ''}`}>
//         <div className="glass-card">
          
//           <div className="card-header">
//             <img src={topLogo} alt="Logo" className="card-logo floating-logo" />
//             <h1 className="hindi-title">गायत्री परिवार</h1>
//             <h2 className="hindi-subtitle">अलीराजपुर</h2>
            
//             {/* Dynamic Welcome Text */}
//             <h3 className="hindi-welcome">
//                 {isResetMode ? "पासवर्ड बदलें" : "आपका स्वागत करता है"}
//             </h3>
//           </div>

//           <div className="form-body">
            
//             {/* Contact Input (Used for both) */}
//             <div className="input-group">
//               <div className="icon-box"><FaUser /></div>
//               <span className="prefix">+91</span> 
//               <div className="vertical-line"></div>
//               <input 
//                 type="tel" 
//                 placeholder="Mobile Number" 
//                 className="modern-input"
//                 value={contact}
//                 onChange={handleContactChange}
//               />
//             </div>

//             {/* Password Input (Used as 'Password' or 'New Password') */}
//             <div className="input-group">
//               <div className="icon-box">{isResetMode ? <FaKey /> : <FaLock />}</div>
//               <input 
//                 type={showPassword ? "text" : "password"} 
//                 placeholder={isResetMode ? "Enter New Password" : "Password"} 
//                 className="modern-input" 
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//               />
//               <div className="icon-box eye-icon" onClick={() => setShowPassword(!showPassword)}>
//                 {showPassword ? <FaEyeSlash /> : <FaEye />}
//               </div>
//             </div>

//             {/* Actions / Links */}
//             <div className="actions">
//               {isResetMode ? (
//                   // If in Reset Mode, show "Back to Login"
//                   <span className="forgot-link" onClick={() => setIsResetMode(false)} style={{cursor:'pointer'}}>
//                     Back to Login
//                   </span>
//               ) : (
//                   // If in Login Mode, show "Forgot Password"
//                   <span className="forgot-link" onClick={() => setIsResetMode(true)} style={{cursor:'pointer'}}>
//                     Forgot Password?
//                   </span>
//               )}
//             </div>

//             {/* Button Changes based on Mode */}
//             {isResetMode ? (
//                 <button className="gradient-btn" onClick={handleResetPassword} style={{background: 'linear-gradient(90deg, #FF512F 0%, #DD2476 100%)'}}>
//                     UPDATE PASSWORD
//                 </button>
//             ) : (
//                 <button className="gradient-btn" onClick={handleLogin}>
//                     LOGIN
//                 </button>
//             )}
            
//           </div>

//           <div className="card-footer">
//              <img src={bottomTorch} alt="Torch" className="footer-logo" />
//           </div>

//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// Added FaKey (for new password) and FaEnvelope (for OTP)
import { FaUser, FaLock, FaEye, FaEyeSlash, FaKey, FaEnvelope } from 'react-icons/fa'; 
import './Login.css';

// Replace with your actual image paths
import topLogo from './logo-placeholder.png'; 
import bottomTorch from './torch-placeholder.png'; 

const Login = () => {
  const navigate = useNavigate();
  
  // --- UI STATE ---
  const [showPassword, setShowPassword] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [isResetMode, setIsResetMode] = useState(false); // Toggle Login vs Forgot Password
  const [otpSent, setOtpSent] = useState(false);         // Has OTP been sent?

  // --- DATA STATE ---
  const [contact, setContact] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');

  // Animation on load
  useEffect(() => {
    setLoaded(true);
  }, []);

  // Handle Mobile Number Input (Numbers Only, Max 10)
  const handleContactChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 10) {
      setContact(value);
    }
  };

  // --- 1. LOGIN FUNCTION ---
  const handleLogin = async () => {
    if (contact.length < 10) {
      alert("Please enter a valid 10-digit Mobile Number.");
      return;
    }
    if (!password) {
      alert("Please enter your password.");
      return;
    }

    try {
      const response = await fetch('/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contact, password }),
      });

      const data = await response.json();

      if (data.success) {
        // --- CRITICAL FIX START ---
        // 1. You MUST save the token. PrivateRoute looks for this!
        localStorage.setItem('token', data.token); 
        
        // 2. Save user info (Optional but good)
        localStorage.setItem('user', JSON.stringify(data.user));
        // --- CRITICAL FIX END ---

        //alert("Login Successful!");
        
        // 3. Redirect to Home
        navigate('/home'); 
      } 
      else {
        alert("Login Failed: " + data.message);
      }
    } catch (error) {
      console.error("Login Error:", error);
      alert("Server Error. Ensure Backend is running.");
    }
  };

  // --- 2. SEND OTP FUNCTION ---
  const handleSendOTP = async () => {
    if (contact.length < 10) {
      alert("Please enter your registered Mobile Number.");
      return;
    }
    
    try {
      // Show loading state or alert
      alert("Sending OTP... Please wait.");
      
      const response = await fetch('/forgot-password/send-otp', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ contact }),
      });

      const data = await response.json();

      if (data.success) {
        setOtpSent(true); // Show OTP Input field
        alert(data.message);
      } else {
        alert("Error: " + data.message);
      }
    } catch (error) {
      console.error(error);
      alert("Server Error.");
    }
  };

  // --- 3. VERIFY & RESET PASSWORD ---
  const handleVerifyReset = async () => {
    if (!otp || !password) {
      alert("Please enter the OTP and your New Password.");
      return;
    }

    try {
      const response = await fetch('http://localhost:5000/forgot-password/verify-reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
            contact, 
            otp, 
            newPassword: password 
        }),
      });

      const data = await response.json();

      if (data.success) {
        alert("Success! Password changed. Please Login now.");
        // Reset everything back to Login Mode
        setIsResetMode(false);
        setOtpSent(false);
        setOtp('');
        setPassword('');
        setContact('');
      } else {
        alert("Error: " + data.message);
      }
    } catch (error) {
      console.error(error);
      alert("Server Error.");
    }
  };

  return (
    <div className="main-wrapper">
      <div className="shape shape-1"></div>
      <div className="shape shape-2"></div>
      <div className="shape shape-3"></div>

      <div className={`login-content ${loaded ? 'fade-in' : ''}`}>
        <div className="glass-card">
          
          <div className="card-header">
            <img src={topLogo} alt="Logo" className="card-logo floating-logo" />
            <h1 className="hindi-title">गायत्री परिवार</h1>
            <h2 className="hindi-subtitle">अलीराजपुर</h2>
            <div className="divider"></div>
            
            {/* Dynamic Welcome Text */}
            <h3 className="hindi-welcome">
                {isResetMode ? "पासवर्ड बदलें" : "आपका स्वागत करता है"}
            </h3>
          </div>

          <div className="form-body">
            
            {/* 1. Mobile Number (Always Visible) */}
            <div className="input-group">
              <div className="icon-box"><FaUser /></div>
              <span className="prefix">+91</span> 
              <div className="vertical-line"></div>
              <input 
                type="tel" 
                placeholder="Mobile Number" 
                className="modern-input"
                value={contact}
                onChange={handleContactChange}
                disabled={otpSent} // Lock number after OTP is sent
              />
            </div>

            {/* 2. OTP Input (Only shows after sending OTP) */}
            {isResetMode && otpSent && (
                <div className="input-group">
                  <div className="icon-box"><FaEnvelope /></div>
                  <input 
                    type="text" 
                    placeholder="Enter OTP from Email" 
                    className="modern-input"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                  />
                </div>
            )}

            {/* 3. Password Input */}
            {/* Logic: Show in Login Mode OR (Reset Mode AND OTP Sent) */}
            {(!isResetMode || (isResetMode && otpSent)) && (
                <div className="input-group">
                  <div className="icon-box">
                    {isResetMode ? <FaKey /> : <FaLock />}
                  </div>
                  <input 
                    type={showPassword ? "text" : "password"} 
                    placeholder={isResetMode ? "Enter New Password" : "Password"} 
                    className="modern-input" 
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <div className="icon-box eye-icon" onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </div>
                </div>
            )}

            {/* 4. Links (Toggle Modes) */}
            <div className="actions">
              <span 
                className="forgot-link" 
                onClick={() => {
                  setIsResetMode(!isResetMode);
                  setOtpSent(false); // Reset OTP state if they go back
                  setOtp('');
                  setPassword('');
                }} 
                style={{cursor:'pointer'}}
              >
                {isResetMode ? "Back to Login" : "Forgot Password?"}
              </span>
            </div>

            {/* 5. Dynamic Button */}
            {!isResetMode ? (
                // Login Button
                <button className="gradient-btn" onClick={handleLogin}>
                    LOGIN
                </button>
            ) : (
                // Reset Password Buttons
                !otpSent ? (
                    <button 
                        className="gradient-btn" 
                        onClick={handleSendOTP} 
                        style={{background: 'linear-gradient(90deg, #4a148c 0%, #7b1fa2 100%)'}}
                    >
                        SEND OTP
                    </button>
                ) : (
                    <button 
                        className="gradient-btn" 
                        onClick={handleVerifyReset} 
                        style={{background: 'linear-gradient(90deg, #e65100 0%, #ef6c00 100%)'}}
                    >
                        RESET PASSWORD
                    </button>
                )
            )}
            
          </div>

          <div className="card-footer">
             <img src={bottomTorch} alt="Torch" className="footer-logo" />
          </div>

        </div>
      </div>
    </div>
  );
};

export default Login;